export enum PlacementType {
    Direct = 'Direct',
    Wholesaler = 'Wholesaler',
}
